import { render, staticRenderFns } from "./TeacherTeamSave.vue?vue&type=template&id=69cd0653&"
import script from "./TeacherTeamSave.vue?vue&type=script&lang=js&"
export * from "./TeacherTeamSave.vue?vue&type=script&lang=js&"
import style0 from "./TeacherTeamSave.vue?vue&type=style&index=0&id=69cd0653&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports